import React, { useEffect, useState } from 'react'
import IntlMessages from '@crema/utility/IntlMessages'
import Box from '@material-ui/core/Box'
import GoBack from 'components/GoBack'
import { RouteConfigComponentProps } from 'react-router-config'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { offeringCategoryRetrieveThunk, offeringCategoryUpdateThunk, selectOfferingCategoryById, selectOfferingCategoryStatus } from 'store/reducers/temple/offeringCategorySlice'
import FitContentPaper from 'components/Paper/FitContentPaper'
import FormOfferingCategory from './FormOfferingPool'
import { FormikHelpers } from 'formik'
import { unwrapResult } from '@reduxjs/toolkit'
import { getEditedPayload, getFieldErrors } from 'utils/api'
import { IOfferingCategory } from 'types/store/temple'
import useRestricter from 'hooks/useRestricter'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import FormOfferingPool from './FormOfferingPool'
import { OfferingPoolRequestType, offeringPoolUpdateThunk, selectOfferingPoolById } from 'store/reducers/temple/offeringPoolSlice'

interface Props {
    id: string
}

const EditOfferingPool: React.FC<Props> = (props) => {

    const api = useAppSelector(selectOfferingCategoryStatus)
    const offeringPool = useAppSelector(state => selectOfferingPoolById(state, props.id))
    const [isSuccess, setIsSuccess] = useState(false)
    const [fetched, setFetched] = useState(false)
    const [initialValues, setInitialValues] = useState<OfferingPoolRequestType>({ poolName: '', poolLimit: '' })
    const dispatch = useAppDispatch()
    const hasEditPermission = useRestricter(PERMISSIONS.CHANGE, RESTRICTED_PATHS.OFFERING_CATEGORIES)

    useEffect(() => {
        if (offeringPool) {
            setInitialValues({ poolName: offeringPool.poolName, poolLimit: offeringPool.poolLimit?.toString() })
        }

    }, [dispatch, offeringPool])

    const handleSubmit = (data: OfferingPoolRequestType, actions: FormikHelpers<OfferingPoolRequestType>) => {
        setIsSuccess(false)
        let payload = getEditedPayload(initialValues, data)
        if (payload && offeringPool?.url) {
            dispatch(offeringPoolUpdateThunk({ data: payload, url: offeringPool.url }))
                .then(unwrapResult)
                .then(() => setIsSuccess(true))
                .catch(err => {
                    Object.entries(getFieldErrors(data, err)).forEach(([key, value]) =>
                        actions.setFieldError(key, value))
                })
                .finally(() => {
                    actions.setSubmitting(false)
                })
        } else {
            actions.setSubmitting(false)
        }
    }
    const handleSuccess = () => isSuccess ? 'Offering pool updated' : ''

    if (!hasEditPermission) return null

    return (
        <FitContentPaper style={{height:'fit-content'}}>
            <Box component="h5" mb={4}><IntlMessages id="offeringCategory.edit.title" /></Box>
            <FormOfferingPool
                buttonLabelId="common.update"
                api={api}
                initialValues={initialValues}
                onSubmitCb={handleSubmit}
                isSuccess={isSuccess}
                successCb={handleSuccess}
            />
        </FitContentPaper>
    )
}

export default EditOfferingPool